export default {
  LIST(state, data) {
    state.scientificWorks = data
  },
  GET(state, data) {
    state.scientificWork = data
  },
  UPDATE(state, value) {
    state.scientificWork = {
      ...value,
    }
  },
  FRESH(state) {
    state.scientificWork = {
      id: null,
      scientific_work_name: '',
      publication_date: '',
      scientific_work_type: null,
      scientific_work: null,
      scientific_work_url: null,
    }
  },
}
